// src/components/evidence/EvidencePreviewCard.jsx
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { Badge } from "components/ui/badge";
import { ExternalLink } from "lucide-react";

export default function EvidencePreviewCard({ data, compact = false }) {
  if (!data) return null;
  const { url, title, description, image, siteName, favicon } = data;

  return (
    <Card
      className="overflow-hidden"
      
    >
      {!compact && image ? (
        <div className="w-full h-36 bg-gray-100 overflow-hidden">
          <img src={image} alt={title || url} className="w-full h-full object-cover" />
        </div>
      ) : null}

      <CardHeader className="pb-2">
        <div className="flex items-center gap-2">
          {favicon ? <img src={favicon} alt="" className="w-4 h-4 rounded-sm" /> : null}
          <Badge variant="secondary" className="text-xs">
            {siteName || new URL(url).hostname.replace(/^www\./, "")}
          </Badge>
        </div>
        <CardTitle className="text-sm leading-snug mt-2">{title || url}</CardTitle>
      </CardHeader>

      <CardContent className="pt-0">
        {!compact && <p className="text-sm text-slate-600 line-clamp-3">{description}</p>}
        <a href={url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm mt-3 text-blue-700 hover:underline">
          Visit link <ExternalLink className="w-4 h-4" />
        </a>
      </CardContent>
    </Card>
  );
}
